import { gql } from "@apollo/client";

const DASHBOARD_STATS = gql`
  query allDashboardStats($platform: Int, $isAdmin: Boolean) {
    allDashboardStats(platform: $platform, isAdmin: $isAdmin)
  }
`;

export default DASHBOARD_STATS;
